import React from 'react'

import { useLoadedBotHostingId } from '../../../../../../store/app'

export const WebchatSharedWidget: React.FC = (props: any) => {
  const hostingId = useLoadedBotHostingId()?.replace(/^feedbot-/, '')
  const channelId = props.value ? '/' + props.value : ''
  const link = `https://chat.feedyou.ai/${hostingId}${channelId}#feedbot-test-mode`
  const codeLink = `https://chat.feedyou.ai/code/${hostingId}${channelId}`

  return (
    <span style={{ width: 'calc(80% - 26px)' }}>
      {hostingId ? (
        <>
          <a
            key={1}
            title="Opens the new tab with preview of this webchat channel"
            href={link}
            rel="noopener noreferrer"
            className="btn btn-default"
            target="_blank"
            style={{ marginRight: 10 }}
          >
            Preview
          </a>
          <a
            key={2}
            title="Opens the new tab with webchat code page, which tells anybody how to use it on any webpage (you can remove last part of URL to autodetect first webchat config matching URL filter instead of forcing this one)"
            href={codeLink}
            rel="noopener noreferrer"
            className="btn btn-default"
            target="_blank"
            style={{ marginRight: 10 }}
          >
            Code
          </a>
          (new settings will be reflected after next <b>Save</b> and <b>Deploy</b>)
        </>
      ) : (
        ' -'
      )}
    </span>
  )
}
